import { ABU, buildSubView, Em, FormWrapper, playContext, SaleResult, showMsg, TestPage } from "@client";
import { Style } from "@client/style";
import { NpcModel } from "@npc";
import { calcBuyNowP, calcScore, getXPercent, SaleX, SceneConst, SubNamespace, waitSeconds } from "@share";
import { Button, Form, Input, InputNumber, message, Radio } from "antd";
import React, { useContext, useState } from "react";

function Play({ playDone }: { playDone: () => void }) {
  const { saveResult } = useContext(playContext);
  const [p1, setP1] = useState(null as number),
    [p2, setP2] = useState(null as number),
    [saleXList, setSaleXList] = useState(null! as SaleX[]);
  if (saleXList) {
    return <SaleResult sale_X={saleXList} />;
  }
  return (
    <FormWrapper>
      <Form style={{ margin: "2rem" }}>
        <Form.Item label="产品成本">
          <span>{SceneConst.saleCar.cost}</span>&nbsp;万
        </Form.Item>
        <Form.Item label="优惠价格">
          <InputNumber min={SceneConst.saleCar.cost} max={1e4} value={p1} onChange={(val: number) => setP1(val)} />
          &nbsp;万
        </Form.Item>
        <Form.Item label="普通价格">
          <InputNumber
            min={SceneConst.saleCar.cost}
            max={1e4}
            value={p2}
            placeholder={`${SceneConst.saleCar.price.MIN}~${SceneConst.saleCar.price.MAX}`}
            onChange={(val: number) => setP2(val)}
          />
          &nbsp;万
        </Form.Item>
        <div style={{ textAlign: "center" }}>
          <Button
            className={Style.btnPrimarySm}
            onClick={async () => {
              if (!p1 || !p2) {
                return message.warn("请检查你的定价");
              }
              const { pBuy, pBuyNow } = calcBuyNowP(SceneConst.saleCar.cost, p1, p2);
              const saleXList = Array(SceneConst.saleCar.buyerAmount)
                .fill(null)
                .map(() =>
                  Math.random() < pBuy ? (Math.random() < pBuyNow ? SaleX.BuyNow : SaleX.BuyLater) : SaleX.NoBuy
                );
              setSaleXList(saleXList);
              const X_buyNow = getXPercent(saleXList, SaleX.BuyNow),
                X_buyLater = getXPercent(saleXList, SaleX.BuyLater),
                X_noBuy = getXPercent(saleXList, SaleX.NoBuy),
                profit =
                  SceneConst.saleCar.buyerAmount *
                  (X_buyLater * (p1 - SceneConst.saleCar.cost) + X_buyNow * (p2 - SceneConst.saleCar.cost));
              await waitSeconds(3);
              await showMsg(
                <p>
                  你设置了优惠价格<Em>{p1}万</Em>
                  ，和普通价格<Em>{p2}万</Em>。有
                  <Em>{(X_buyNow * 100).toFixed(2)}%</Em>
                  %的买家选择了支付优惠价格并且购买；有
                  <Em>{(X_buyLater * 100).toFixed(2)}</Em>
                  %的买家选择了搜寻，但最终返回购买；有
                  <Em>{(X_noBuy * 100).toFixed(2)}</Em>
                  %的买家选择了不购买。因此你的利润为
                  <Em>{profit.toFixed(2)}万</Em>
                </p>,
                {
                  okText: "知道了",
                }
              );
              saveResult({
                score: calcScore(
                  0,
                  saleXList.filter((s) => s !== SaleX.NoBuy).length,
                  SceneConst.saleFurniture.buyerAmount
                ),
                p1,
                p2,
                saleXList,
              });
              playDone();
            }}
          >
            确定
          </Button>
        </div>
      </Form>
    </FormWrapper>
  );
}

function Test({ done }: { done: (answers, answerScores) => void }) {
  return (
    <TestPage
      questions={[
        {
          Content: ({ inputProps }) => (
            <div>
              <p>
                假设某一产品在市场中的现有价格均为1000，首次购买优惠100元。如果一位买家认为其货币效用为1200，如果搜寻可能有50%的概率发现效用=1500的产品，有50%的概率发现效用=1000的产品。买家的搜寻成本为80。买家预期，在同类市场中，类似产品的价格同为900元。在这样的情形下，买家应如何决策？
              </p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A. 直接购买</Radio>
                <Radio value={2}>B. 搜寻</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => (
            <p>
              买家的现有净收益为1200-900=300
              <br />
              买家的预期净收益为(1500+1000)/2-900 = 350
              <br />
              搜寻产生的净剩余为350-300-80&lt;0 不应该搜寻
            </p>
          ),
          answer: [1],
        },
        {
          Content: ({ inputProps }) => (
            <div>
              <p>
                一位买家访问一位卖家，并且检视某一产品/服务，该产品/服务的价值服从某一分布。比如u服从0-1均匀分布。买家知道他有一个【外部选项】，该外部选项也服从某一分布，比如外部选项v也服从0-1均匀分布。买家在选择搜寻外部选项是，会有潜在的搜寻成本，比如s=1/18。如果卖家使用限时优惠的销售策略，并且设置p
                （先买优惠价）和 p+τ （返回时的原价），则卖方的价格p和优惠τ为：
              </p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A.优惠价格5/18，优惠0.121</Radio>
                <Radio value={2}>B.优惠价格1/18，优惠0.121</Radio>
                <Radio value={3}>C.优惠价格5/18，优惠0.021</Radio>
                <Radio value={4}>D.优惠价格1/3，优惠0.021</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => <img src={`${ABU}answer/8.2.png`} />,
          answer: [1],
        },
        {
          isAnalysis: true,
          Content: ({ inputProps }) => (
            <div>
              <p>请在以下双选任务中选择更偏好的那个。本题为主观题，无正确的答案，可以简单说明理由。</p>
              <ul>
                {[
                  ["A.\t50% 概率 失去0元，50% 概率失去4000 元", "B.\t100% 失去 1800 元"],
                  ["A.\t50% 概率 失去0元，50% 概率失去4000 元", "B.\t100% 失去 1900 元"],
                  ["A.\t50% 概率 失去0元，50% 概率失去4000 元", "B.\t100% 失去 2000 元"],
                  ["A.\t50% 概率 失去0元，50% 概率失去4000 元", "B.\t100% 失去 2100 元"],
                  ["A.\t50% 概率 失去0元，50% 概率失去4000 元", "B.\t100% 失去 2200 元"],
                  ["A.\t50% 概率 失去0元，50% 概率失去4000 元", "B.\t100% 失去 2300 元"],
                  ["A.\t50% 概率 失去0元，50% 概率失去4000 元", "B.\t100% 失去 2400 元"],
                ].map(([optionA, optionB]) => (
                  <li style={{ listStyle: "decimal" }}>
                    <Radio.Group {...inputProps({ margin: ".5rem" })}>
                      <Radio value={1}>{optionA}</Radio>
                      <Radio value={2}>{optionB}</Radio>
                    </Radio.Group>
                  </li>
                ))}
              </ul>
              <br />
              <Input.TextArea maxLength={2e3} rows={4} {...inputProps({ width: "100%" })} />
            </div>
          ),
        },
      ]}
    />
  );
}

export const SaleCarView = buildSubView({
  namespace: SubNamespace.SaleCar,
  bg: `${ABU}scene/bg/SaleCar.jpg`,
  label: "卖车",
  npcModel: NpcModel.BuyInsurance,
  introMsg: () => [
    ...`1.\t假设买家有一个单位的购买需求。买家总会先访问你。
2.\t买家访问你时将了解到你的产品对于他的“货币效用”和需要购买产品所支付的价格。
3.\t买家有以下几种选择：（1）购买你的产品，获得产品的净收益（2）放弃购买，选择搜寻，并以一定的概率获得一个“外部收益”。
`
      .trim()
      .split("\n"),
    <p>
      4.买家的“货币效用”和“外部收益”均服从
      <Em>
        {SceneConst.saleCar.utility.MIN}，{SceneConst.saleCar.utility.MAX}
      </Em>
      万之间的均匀分布。
    </p>,
    ...`
5.\t你可以选择两种销售模式。在常规销售模式下，你选择一个单一的出售价格，买家可以选择搜寻以后返回购买；在限时优惠模式下，你需要选择优惠价格和非优惠价格，买家在放弃首次购买机会后，必须支付非优惠价格，才能选择返回购买
6.\t买家的搜寻成本为【${(SceneConst.saleCar.cost * 100).toFixed(1)}】。`
      .trim()
      .split("\n"),
  ],
  npcWelcome: async () => {
    await showMsg("现在你作为销售人员，需要对公司的销售策略做出建议。你任职于一家汽车销售部门。");
    await showMsg(
      "该市场中有大量的买家，假设这些买家将完全基于最大化个人期望收益来选择行动。你需要帮助公司决定最优销售策略。",
      {
        okText: "下一步",
      }
    );
  },
  Play,
  Test,
  initState: (s) => s,
});
